export default {
    home_search_for_product: "Vyhľadajte svoj produkt",
conventional_alternative: "Konvenčná alternatíva",
led_alternative: "LED alternatíva",
search_filters_filter: "Filter",
search_submit: "Vyhľadať produkt",
results: "Výsledky",
selected_product: "Vybraný produkt",
search_input: "Zadajte kód (jeho časť) či popis produktu",
what_type_are_you_looking_for: "Aký typ náhrady produktu hľadáte?",
recommendations_singular: "Odporúčanie",
recommendations_plural: "Odporúčanie",
your_product: "Váš produkt",
search_filters_reset: "Zrušiť filtre",
results_specify: "Našli sme viac ako 10 výsledkov, upresnite prosím svoje vyhľadávanie.",
energy_efficient: "Energeticky účinné",
active_filters: "Aktívne filtre",
card_action: "Katalóg",
card_show_more: "Zobraziť viac",
card_show_less: "Zobraziť menej",
card_alternative_fit: "Najlepšia Philips alternatíva",
card_perfect_fit: "Philips Best Fit alternatíva",
no_results_found: "Neboli nájdené žiadne výsledky. Skúste to znova.",
results_no_recommendations: "Neviete si rady? Obráťte sa na svojho obchodného zástupcu a nájdite riešenie spoločne.",
search_filter_product_type: "Typ produktu",
lighting_type: "Typ svetelného zdroja",
ean: "EAN",
product_code: "Kód produktu",
eoc: "EOC",
family: "Produktový rad",
discrete_wattage: "Príkon",
wattage: "Príkon",
brand: "Značka",
driver_type: "Typ ovládača",
number_of_lamps: "Montážny otvor",
length: "Dĺžka",
color: "Farba",
base: "Pätica",
local_eoc: "Lokálny kód",
ignitor: "Zapaľovač",
height: "Výška",
width: "Šírka",
mounting_hole: "Šírka",
mains_voltage: "Sieťové napätie",
thermal_protection: "Tepelná ochrana",
delta_temperature: "Delta teploty",
energy_efficiency: "Energetická účinnosť",
losses: "Straty energie",
lamp_current: "Prúd žiarovky",
pf_cap: "PF uzáver",
lumen: "Svetelný tok",
energy_saving: "Úspora energie",
led_no_recommendations: "Pre tento produkt neexistujú žiadne alternatívy LED.",
};